import classNames from 'classnames';
import React, { useEffect, useState } from 'react';

type CheckboxProps = {
	defaultChecked?: boolean
	id: string
	name: string
	label: string
	labelClassName?: string
	onCheckedChange?: (checked: boolean) => any
	checkedValue: boolean
}

const Checkbox = ({ defaultChecked = false, id, name, onCheckedChange, checkedValue: checkedValue, label, labelClassName }: CheckboxProps) => {

	const [checked, setChecked] = useState(defaultChecked);

	if (onCheckedChange) {
		useEffect(() => {
			onCheckedChange(checked);
		}, [checked]);
	}

	useEffect(() => {
		if (checked !== checkedValue) setChecked(checkedValue);
	}, [checkedValue]);

	return <div className={classNames({ 'd-flex align-items-baseline': true, [`${labelClassName}`]: labelClassName !== undefined })}>
		<div className='d-flex'
		>
			<input
				type='checkbox'
				className='mr-2 mt-2'
				style={{ accentColor: '#009aa8' }}
				id={id}
				name={name}
				checked={checked}
				onChange={() => {
					setChecked(currVal => !currVal);
				}}
			/>
		</div>
		<div>{label}</div>
	</div>;
};

export default Checkbox;